import {DeserializeCallbackFunc, IPropSchema, Primitive} from '@mintdata/mint-kit/impl/util/serializr/src/api/types';
import {invariant, isPrimitive} from '../utils/utils';

/**
 * Indicates that this field contains a primitive value (or Date) which should be serialized literally to json.
 *
 * @example
 * createModelSchema(Todo, {
 *     title: primitive(),
 * });
 *
 * console.dir(serialize(new Todo('test')));
 * // outputs: { title : "test" }
 *
 * @returns {ModelSchema}
 */
export function primitive():IPropSchema
{
    return {
        serializer: function(value:Primitive):Primitive
        {
            invariant(isPrimitive(value), 'this value is not primitive: ' + value);

            return value;
        },
        deserializer: function(jsonValue:Primitive, done:DeserializeCallbackFunc):void
        {
            if( !isPrimitive(jsonValue) )
                return done('[serializr] this value is not primitive: ' + jsonValue);

            done(null, jsonValue);
        }
    };
}
